const { pick } = require("ramda");

angular.module("ticketco/ticketbuyer/contact_organizer")
  .factory("contactOrganizerPersistanceService", contactOrganizerPersistanceService);

function contactOrganizerPersistanceService($http) {

  function url(data) {
    if (data.event_id) {
      return "/events/" + data.event_id + "/messages";
    } else if (data.organizer_id) {
      return "/messages";
    } else {
      console.error("Can't generate URL without event_id or organizer_id");
    }
  }

  var permittedParams = pick(["name", "email", "body", "token"]);

  function create(message) {
    return $http.post(url(message), {
      message: permittedParams(message)
    });
  };

  return {
    create: create
  }
}

